import React from "react";
import { Badge, Stack, ThemeIcon, Tooltip } from "@mantine/core";
import { IconAlertCircle, IconClock } from "@tabler/icons";
import McaPendingBanner from "./McaPendingBanner";
import {
  getActiveMcaRequest,
  getMcaApprovalBadgeColor,
  getMcaApprovalLabel,
  getMcaApprovalTooltip,
} from "./mcaApprovalLabels";

export {
  getActiveMcaRequest,
  getMcaApprovalLabel,
  getMcaApprovalTooltip,
  isEntityMcaLocked,
} from "./mcaApprovalLabels";

const McaApprovalBadge = ({ request, label, color, sx }) => {
  const tooltip = getMcaApprovalTooltip(request);
  const badge = (
    <Badge size="xs" color={color} radius={0} sx={sx}>
      {label}
    </Badge>
  );

  if (!tooltip) return badge;

  return (
    <Tooltip label={tooltip} withArrow openDelay={300}>
      <span style={{ display: "inline-flex" }}>{badge}</span>
    </Tooltip>
  );
};

const McaApprovalIcon = ({ request, color }) => {
  const tooltip =
    getMcaApprovalTooltip(request) ||
    getMcaApprovalLabel(request.action, request.status);
  const rejected = request.status === "REJECTED";

  return (
    <Tooltip label={tooltip} withArrow openDelay={300}>
      <span style={{ display: "inline-flex" }}>
        <ThemeIcon
          size={16}
          radius="xl"
          variant="light"
          color={color}
          aria-label={tooltip}
        >
          {rejected ? <IconAlertCircle size={12} /> : <IconClock size={12} />}
        </ThemeIcon>
      </span>
    </Tooltip>
  );
};

export const McaApprovalListBadge = ({
  entity,
  inline = true,
  compact = false,
}) => {
  const request = getActiveMcaRequest(entity);
  if (!request) return null;

  const label = getMcaApprovalLabel(request.action, request.status);
  const color = getMcaApprovalBadgeColor(request.status);

  if (compact) {
    return <McaApprovalIcon request={request} color={color} />;
  }

  if (inline) {
    return <McaApprovalBadge request={request} label={label} color={color} />;
  }

  return (
    <Stack spacing={2}>
      <McaApprovalBadge request={request} label={label} color={color} />
    </Stack>
  );
};

export const McaApprovalListFooter = ({ entity }) => (
  <McaApprovalListBadge entity={entity} />
);

export const mcaListColumn = () => ({
  field: "mcaPending",
  headerName: "MCA",
  width: 140,
  cellRender: (col, data) => <McaApprovalListBadge entity={data} compact />,
});

export const McaEntityBanner = ({ entity }) => {
  const request = getActiveMcaRequest(entity);
  if (!request) return null;

  return (
    <McaPendingBanner
      requestId={request._id}
      requestCode={request.code}
      action={request.action}
      processName={request.process?.name}
      status={request.status}
    />
  );
};
